module.exports = __webpack_public_path__ + "img/beem-03.a650649e.png";